"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolarAreaChart = exports.BarChart = void 0;
var PolarAreaChart_1 = require("./chartjs/PolarAreaChart");
exports.PolarAreaChart = PolarAreaChart_1.default;
var BarChart_1 = require("./chartjs/BarChart");
exports.BarChart = BarChart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/charts/index.js
// module id = 2260
// module chunks = 0